import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import GuestCounterControls
  from '../../components/BasicUI/ControlledInputs/ControlledGuestCountSelect/GuestCounterControls';
import Modal from '../../components/ModalNew/Modal';

/**
 * @param {Array<{name: string, label: string, infoLabel?: string, minimum: number, maximum?: number}>} guestOptions
 * @param {(newValue: Record<string, number>) => void} onChange
 * @param {boolean} open
 * @param {() => void} onClose
 * @param {Record<string, number>} value
 */
const ChangeGuestsModalComponent = ({
  guestOptions,
  onChange,
  open,
  onClose,
  totalMaximum,
  value,
}) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'BookingDatesForm.changeGuestsModalTitle' });
  const confirmLabel = intl.formatMessage({ id: 'BookingDatesForm.confirmGuestsLabel' });

  // Internal state for guest count being edited
  const [internalValue, setInternalValue] = useState(value);

  // Reset internal state when modal opens
  useEffect(() => {
    if (open) {
      setInternalValue(value);
    }
  }, [open, value]);

  // Handle confirm - save changes and close
  const handleConfirm = useCallback(() => {
    onChange(internalValue);
    onClose();
  }, [internalValue, onChange, onClose]);

  return (
    <Modal
      onClose={onClose}
      open={open}
      title={title}
    >
      <Stack direction="column" spacing={3} sx={{ minWidth: 300 }}>
        <GuestCounterControls
          guestOptions={guestOptions}
          onChange={setInternalValue}
          totalMaximum={totalMaximum}
          value={internalValue}
        />
        {totalMaximum != null ? (
          <Typography color="text.secondary" variant="caption">
            {intl.formatMessage(
              { id: 'BookingDatesForm.maxGuestCountInfo' },
              { count: totalMaximum },
            )}
          </Typography>
        ) : null}
        <Button
          fullWidth
          onClick={handleConfirm}
          variant="contained"
        >
          {confirmLabel}
        </Button>
      </Stack>
    </Modal>
  );
};

const ChangeGuestsModal = memo(ChangeGuestsModalComponent);

export default ChangeGuestsModal;
